import { AxiosError } from 'axios';
import React from 'react';

import { CommonModal } from '~src/commons/components/common-modal';
import { useTranslations } from '~src/commons/utils/translations/translate';

interface GeneralErrorProps {
  error?: AxiosError | string | null;
  onClose: () => void;
}

export const GeneralError: React.FC<GeneralErrorProps> = ({ error, onClose }) => {
  const { tICU } = useTranslations();

  if (error) {
    return (
      <CommonModal
        title={tICU('widget.GENERAL_ERROR_MESSAGE.TITLE')}
        body={tICU('widget.GENERAL_ERROR_MESSAGE.TEXT')}
        primaryButtonText={tICU('widget.GENERAL_ERROR_MESSAGE.CONFIRMATION_BTN')}
        onPrimaryButtonClick={onClose}
        onClose={onClose}
      />
    );
  }

  return null;
};
